var map = {
	"./ic_arbitrum_24.svg": 447,
	"./ic_avalanche_24.svg": 448,
	"./ic_avax_24.svg": 449,
	"./ic_btc.b_24.svg": 450,
	"./ic_btc_24.svg": 451,
	"./ic_busd_24.svg": 452,
	"./ic_dai_24.svg": 453,
	"./ic_eth_24.svg": 454,
	"./ic_frax_24.svg": 455,
	"./ic_glp_24.svg": 456,
	"./ic_gmx_24.svg": 457,
	"./ic_link_24.svg": 458,
	"./ic_mim_24.svg": 459,
	"./ic_settings_24.svg": 460,
	"./ic_tether_24.svg": 461,
	"./ic_uni_24.svg": 462,
	"./ic_usdc.e_24.svg": 463,
	"./ic_usdc_24.svg": 464,
	"./ic_usdt_24.svg": 465,
	"./ic_wallet_24.svg": 466,
	"./ic_wavax_24.svg": 467,
	"./ic_weth_24.svg": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;